export const MODEL_NAMES = {
  CONTACT: 'messaging-contact',
  CONVERSATION: 'messaging-conversation',
  MESSAGE: 'messaging-message',
  PROFILE: 'messaging-profile',
  SYSTEM_USER: 'messaging-system-user',
  USER: 'messaging-user',
};
